import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SchoolIcon(props: IconProps) {
    return <Icon {...props} iconKey={"school"}/>
}
